import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledHeader = styled.th`
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: #767676;
  border: none !important;
  padding: 0.5rem 1rem 0.5rem 0rem !important;
`;

export const StyledTableHead = styled.thead`
  position: sticky;
`;

export const StyledColumn = styled.div`
  width: 150px;
`;
export const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 12px;
  margin-left: 4px;
  margin-bottom: 1px;
`;
